<template>
  <div class="container">
    <div class="box-title">
      <h4 style="margin-bottom: 4px;">
        <i class="fal fa-ban"></i>
        ສາຂາປາຍທາງທີ່ຖືກລັອກ (ຫ້າມຍິງອອກ/ແພັກເຂົ້າສູນນີ້)
        <span class="countTotal">({{ blockedBranches.length }})</span>
        <span class="btn-add">
                    <vs-button circle icon flat @click="OpenModalAdd()" :disabled="!branches.length > 0">
                        <i class="fal fa-plus-circle"></i>
                    </vs-button>
        </span>
      </h4>
    </div>
    <div class="center">
      <vs-table>
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ສາຂາປາຍທາງທີ່ຖືກລັອກ</vs-th>
            <vs-th>ຕົ້ນທາງທີ່ຖືກລັອກ</vs-th>
            <vs-th></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr v-for="(item, index) in blockedBranches" :key="index">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ item.province_prefix }}-{{ item.branch_name }}</vs-td>
            <vs-td>{{ item.origin_id ? item.origin_name : 'ທຸກຕົ້ນທາງ' }}</vs-td>
            <vs-td>
              <vs-button circle icon flat danger
                         @click="OpenModalDelete(item.id)">
                <i class="fad fa-trash-alt"></i>
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>

    <vs-dialog prevent-close v-model="addModalActive">
      <AddBlockedBranch @close="closeModal('add')" @success="onSuccess()"
                        :activeDistributionCenterId="routeDistributionCenterId"
                        :branches="branches"/>
    </vs-dialog>

    <vs-dialog prevent-close v-model="deleteModalActive">
      <DeleteBlockedBranch @close="closeModal('delete')" @success="onSuccess()"
                           :blockedBranchId="blockedBranchId"/>
    </vs-dialog>

  </div>
</template>

<script>
import AddBlockedBranch from './Dialog/AddBlockedBranch.vue';
import DeleteBlockedBranch from './Dialog/DeleteBlockedBranch.vue';
import Loading from '@/views/Loading';

export default {
  components: {
    AddBlockedBranch,
    DeleteBlockedBranch,
    Loading
  },

  data: () => ({
    branches: [],
    blockedBranches: [],
    blockedBranchId: '',
    isLoading: false,
    addModalActive: false,
    deleteModalActive: false,
  }),
  computed: {
    routeDistributionCenterId() {
      return this.$route.params.id;
    }
  },

  methods: {
    closeModal(id) {
      if (id === 'add') {
        this.addModalActive = false;
      } else {
        this.deleteModalActive = false;
      }
    },
    OpenModalAdd() {
      this.addModalActive = true;
    },
    OpenModalDelete(blockedBranchId) {
      this.blockedBranchId = blockedBranchId;
      this.deleteModalActive = true;
    },
    fetchBranches() {
      this.$http.get('v1/listing/branches?is_active=true').then(res => {
        this.branches = res.data;
      }).catch(() => {
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$axios.get('list-distribution-center-blocked-branches/' + this.routeDistributionCenterId)
          .then((res) => {
            this.blockedBranches = res.data.listBlockedBranches;
          }).catch(() => {
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onSuccess() {
      this.fetchData();
      this.fetchBranches();
    }
  },
  created() {
    this.fetchData();
    this.fetchBranches();
  }

}
</script>
